import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class BaseService {

  apiUrl = environment.apiUrl;

  constructor(protected http: HttpClient,
              protected router: Router,
              protected cookieService: CookieService){
  }

  protected apiSocketUrl(): string{
    return this.apiUrl.replace('http', 'ws');
  }

  protected get options(): any{
    return { headers: this.headers, withCredentials: true, observe: 'response' };
  }

  protected blobOptions(params?: HttpParams): {}{
    const options = {
      headers: this.headers,
      params,
      observe: 'body',
      responseType: 'blob',
    };

    options.headers.set( 'Accept', 'application/pdf' );

    return options;
  }
  protected docxOptions(params?: HttpParams): {} {
    const options = {
      headers: this.headers,
      params,
      observe: 'body' as const,
      responseType: 'blob' as 'blob',
    };

    options.headers = options.headers.set(
      'Accept',
      '*/*'
    );

    return options;
  }
  protected zipOptions(params?: HttpParams): {}{
    const options = {
      headers: this.headers,
      params,
      observe: 'response',
      responseType: 'arraybuffer',

    };

    options.headers.set( 'Accept', 'application/zip' );

    return options;
  }

  protected getJwtToken(): string{
    return `Bearer ${ this.cookieService.get( 'idToken' ) }`;
  }

  protected get headers(): HttpHeaders{
    let headers = new HttpHeaders();

    headers = headers.set( 'Content-Type', 'application/json' );
    headers = headers.set( 'Accept', 'application/json' );

    const token = this.cookieService.get( 'idToken' );
    const association = this.cookieService.get( 'association' );

    if ( !!token ) {
      headers = headers.set( 'Authorization', `Bearer ${ token }` );
    }

    if ( !!association ) {
      headers = headers.set( 'Association', association );
    }

    return headers;
  }

  protected includeHeader(header: { name: string, value: string }): void{
    this.headers.set( header.name, header.value );
  }

  protected authOptions(params?: HttpParams): {}{
    let headers = new HttpHeaders();

    const token = this.cookieService.get( 'idToken' );
    const association = this.cookieService.get( 'association' );

    if ( !!token ) {
      headers = headers.set( 'Authorization', `Bearer ${ token }` );
    }

    if ( !!association ) {
      headers = headers.set( 'Association', association );
    }

    return { headers, params };
  }

  protected httpOptions(params?: HttpParams): {}{
    return { headers: this.headers, params };
  }

  post<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [ header: string ]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [ param: string ]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
  }): Observable<T>{
    return this.http.post<T>( `${ this.apiUrl }${ url }`, body, options );
  }

  get<T>(url: string, options?: {
    headers?: HttpHeaders | {
      [ header: string ]: string | string[];
    };
    params?: HttpParams | {
      [ param: string ]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
  }): Observable<T>{
    return this.http.get<T>( `${ this.apiUrl }${ url }`, options );
  }

  put<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [ header: string ]: string | string[];
    };
    params?: HttpParams | {
      [ param: string ]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
  }): Observable<T>{
    return this.http.put<T>( `${ this.apiUrl }${ url }`, body, options );
  }

  patch<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [ header: string ]: string | string[];
    };
    params?: HttpParams | {
      [ param: string ]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
  }): Observable<T>{
    return this.http.patch<T>( `${ this.apiUrl }${ url }`, body, options );
  }

  delete<T>(url: string, options?: {
    headers?: HttpHeaders | {
      [ header: string ]: string | string[];
    };
    params?: HttpParams | {
      [ param: string ]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
  }): Observable<T>{
    return this.http.delete<T>( `${ this.apiUrl }${ url }`, options );
  }
}
